import Layout from '@/components/layout/index.vue'

export default {
  path: 'signature-manage',
  name: 'SignatureManage',
  meta: {},
  component: Layout,
  redirect: { name: 'SignatureManage.Signature' },
  children: [
    {
      path: 'signature',
      name: 'SignatureManage.Signature',
      meta: {},
      component: () => import(/* webpackChunkName: "signature-manage" */ '@/views/purchaser/signature-manage/signature/index.ts')
    },
    {
      path: 'signature/detail',
      name: 'SignatureManage.Signature.Detail',
      meta: { title: 'common.detail', dep: 'SignatureManage.Signature' },
      component: () => import(/* webpackChunkName: "signature-manage" */ '@/components/iframe/iframe-detail.vue'),
      props: (route) => ({ url: route.query.url })
    }
  ]
}
